import { render, staticRenderFns } from "./OperatorProductivityChart.vue?vue&type=template&id=168e6059&scoped=true"
import script from "./OperatorProductivityChart.vue?vue&type=script&lang=js"
export * from "./OperatorProductivityChart.vue?vue&type=script&lang=js"
import style0 from "./OperatorProductivityChart.vue?vue&type=style&index=0&id=168e6059&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168e6059",
  null
  
)

export default component.exports